export default __webpack_public_path__ + "static/media/undraw_data.3c2ec097.svg";